<template>
  <div class="login">
    <div class="login-documents">
      <a href="https://rosporc.bcr.com.ar/documentos.html" rel="noopener noreferrer">Reglamentos y Documentos</a>
    </div>
    <div class='login-form'>
      <div class="header">
        <img alt="BCR logo" src="@/assets/images/front_logo.svg">
        <div v-if="inMaintenance()" class="alert danger"><vs-icon icon="info"></vs-icon>El sitio se encuentra en mantenimiento. Disculpe las molestias.</div>
        <div v-if="offline" class="alert danger fixed">
          Estas en modo offline, algunas funciones pueden no estar disponibles.
        </div>
      </div>
      <LoginForm/>
      <div class="register">
        ¿No eres usuario todavía? <router-link data-test="register" to="/signup">Registrate aquí</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue'
import axios from 'axios'

axios.defaults.headers.common['referer-id'] = new Date().toLocaleString().replace(/[^\d]/g, '') + parseInt(Math.random() * 100000)

export default {
  name: 'login',
  components: {
    LoginForm
  },
  data () {
    return {
      offline: false
    }
  },
  beforeMount () {
    window.addEventListener('online', this.handleNetworkChange);
    window.addEventListener('offline', this.handleNetworkChange);
    this.handleNetworkChange()
  },
  methods: {
    inMaintenance () {
      return !!localStorage.getItem('IN_MAINTENANCE')
    },
    handleNetworkChange () {
      if (navigator.onLine) {
        this.offline = false
      } else {
        this.offline = true
      }
    }
  }
}
</script>
